import React, { FunctionComponent } from 'react';
import Tooltip from '@liveramp/motif/core/Tooltip';
import IconButton from '@liveramp/motif/core/IconButton';
import Loader from '@liveramp/motif/core/Loader';

interface Props {
  icon: any
  onClick: () => void
  isDisabled: boolean
  tooltipText: string
  isLoading: boolean
  dataTestId: string
}

const EditBarIconButton: FunctionComponent<Props> = ({
  icon,
  onClick,
  isDisabled,
  tooltipText,
  isLoading,
  dataTestId
}) => (
  <Tooltip title={tooltipText}>
    { isLoading ? <Loader size="small" />
      : (
        <IconButton
          data-test-id={dataTestId}
          onClick={onClick}
          disabled={isDisabled}
        >
          {icon}
        </IconButton>
      )}
  </Tooltip>
);

export default EditBarIconButton;
